import { render } from "./PlansFilterRooms.vue?vue&type=template&id=0080e544&scoped=true"
import script from "./PlansFilterRooms.vue?vue&type=script&lang=js"
export * from "./PlansFilterRooms.vue?vue&type=script&lang=js"

import "./PlansFilterRooms.vue?vue&type=style&index=0&id=0080e544&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0080e544"]])

export default __exports__